<template>
  <v-dialog
    v-model="showModal"
    persistent
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <v-card-title>
        <h2>Filter Timesheets</h2>
      </v-card-title>
      <br>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <div v-if="createAll">
            <v-radio-group
              v-model="radioType"
              class="radio-group"
              row
              light
              :rules="[(v) => !!v || 'This field is required']"
            >
              <v-radio
                label="All Users"
                value="all-users"
                light
                color="#37474F"
                @click="appUser = null"
              >
                <template #label>
                  <p class="type-bottom">
                    All Users
                  </p>
                </template>
              </v-radio>
              <v-radio
                label="Selective User"
                value="selective-user"
                light
                color="#37474F"
              >
                <template #label>
                  <p class="type-bottom">
                    Selective User
                  </p>
                </template>
              </v-radio>
            </v-radio-group>
            <v-select
              v-if="radioType === 'selective-user'"
              v-model="appUser"
              light
              color="#37474F"
              flat
              dense
              :items="acceptedAppUsersList"
              :item-text="user => `${user.first_name} ${user.last_name}`"
              item-value="app_user_organization_id"
              label="User"
              outlined
              class="small-select"
            />
          </div>
          <v-row>
            <v-col cols="6">
              <v-dialog
                :ref="'fromDialog'"
                v-model="timesheetDateStartDateCalender"
                width="290px"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="timesheetStartDate"
                    label="Start Date*"
                    light
                    dense
                    readonly
                    outlined
                    v-bind="attrs"
                    :disabled="checkDateTypeSelected"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-if="timesheetDateStartDateCalender"
                  v-model="timesheetStartDate"
                  full-width
                  color="#37474F"
                  light
                  :max="maxStartDate"
                  @change="timesheetDateStartDateCalender = false"
                >
                  <v-spacer />
                  <v-btn
                    text
                    color="#37474F"
                    @click="timesheetDateStartDateCalender = false"
                  >
                    Cancel
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="6">
              <v-dialog
                :ref="'fromDialog'"
                v-model="timesheetDateEndDateCalender"
                width="290px"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="timesheetEndDate"
                    label="End Date*"
                    light
                    dense
                    readonly
                    outlined
                    v-bind="attrs"
                    :disabled="
                      checkDateTypeSelected || timesheetStartDate === null
                    "
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-if="timesheetDateEndDateCalender"
                  v-model="timesheetEndDate"
                  full-width
                  color="#37474F"
                  light
                  :max="maxStartDate"
                  @change="timesheetDateEndDateCalender = false"
                >
                  <v-spacer />
                  <v-btn
                    text
                    color="#37474F"
                    @click="timesheetDateEndDateCalender = false"
                  >
                    Cancel
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
          <v-select
            v-model="type"
            light
            color="#37474F"
            flat
            dense
            :items="payItems"
            item-text="name"
            item-value="id"
            label="Pay Item"
            outlined
            class="small-select"
          />
          <v-select
            v-model="dateTypeSelected"
            light
            color="#37474F"
            flat
            dense
            :items="dateType"
            item-text="name"
            item-value="id"
            label="Date Type"
            outlined
            background-color="transparent"
            class="small-select"
            :disabled="checkDateSelected"
          />
        </v-form>
        <div class="d-flex justify-space-between align-items-center">
          <div>
            <v-btn
              class="next-style"
              elevation="0"
              color="#64CA7F"
              @click="filter()"
            >
              Filter
            </v-btn>&nbsp;&nbsp;
            <v-btn
              class="cancel-style"
              elevation="0"
              color="#F5F5F5"
              @click="showModal = false"
            >
              Cancel
            </v-btn>
          </div>
          <v-btn
            dark
            fab
            icon
            color="#37474F"
            small
            @click="clearFormFilter()"
          >
            <v-icon
              small
              dark
            >
              mdi-filter-off
            </v-icon>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Constants from 'src/constants';

export default {
  name: 'FilterJobsDialog',
  props: {
    filterStoredData: {
      type: Object,
      default: null,
    },
    filterFrom: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    showModal: true,
    radioType: 'all-users',
    valid: false,
    dateType: [
      {
        name: 'Today',
        id: 'today',
      },
      {
        name: 'Yesterday',
        id: 'yesterday',
      },
      {
        name: 'Last 7 days',
        id: 'this_week',
      },
      {
        name: 'This Month',
        id: 'this_month',
      },
      {
        name: 'Last Month',
        id: 'last_month',
      },
    ],
    timeValues: [
      {
        name: 'Base Hourly',
        id: 'base_hourly',
      },
      {
        name: 'Overtime (1.5x)',
        id: 'over_time_1.5x',
      },
      {
        name: 'Overtime (2x)',
        id: 'over_time_2x',
      },
      {
        name: 'Annual Leave Pay',
        id: 'annual_leave_pay',
      },
      {
        name: 'Personal Leave Pay',
        id: 'personal_leave_pay',
      },
      {
        name: 'Sick Leave Pay',
        id: 'sick_leave_pay',
      },
    ],
    appUser: null,
    dateTypeSelected: null,
    timesheetDateStartDateCalender: false,
    timesheetStartDate: null,
    timesheetDateEndDateCalender: false,
    timesheetEndDate: null,
    type: null,
    createAll: false,
  }),
  computed: {
    checkDateSelected () {
      if (this.timesheetStartDate !== null || this.timesheetEndDate !== null) {
        return true;
      }
      return false;
    },
maxStartDate () {
  if (
    !this.selectedOrganization ||
    !this.selectedOrganization.deactivated_at
  ) {
    return null;
  }

  const date = new Date(this.selectedOrganization.deactivated_at);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
},
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    organizationSettings () {
      return this.$store.getters['organization/getOrganizationSettings'];
    },
    acceptedAppUsersList () {
      return this.$store.getters['appusers/getAcceptedAppUsersList'];
    },
    payItems () {
      return this.$store.getters['timesheets/getPayItems'];
    },
    checkDateTypeSelected () {
      if (this.dateTypeSelected !== null) {
        return true;
      }
      return false;
    },
    // endDateRules () {
    //   if (this.timesheetStartDate !== null) {
    //     return [(v) => !!v || 'This field is required'];
    //   } else {
    //     return [];
    //   }
    // },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  mounted () {
    this.checkTimesheetPermissions();
    this.fetchPayItems();
    this.fillData();
  },
  methods: {
    checkTimesheetPermissions () {
      const role = this.selectedOrganization.app_user_role;
      const allPermissions = this.organizationSettings.timesheet_permissions;
      let rolePer = null;

      if (allPermissions !== null) {
        switch (role) {
          case 'site-manager':
            rolePer = allPermissions.site_manager;
            break;
          case 'worker':
            rolePer = allPermissions.worker;
            break;
          case 'contractor':
            rolePer = allPermissions.contractor;
            break;
        }
      }
      this.createAll = rolePer.create.all;
      if (rolePer.create.all) {
        this.fetchAcceptedAppUsers();
      }
      return rolePer;
    },
    filter () {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Please fill the required fields before proceeding',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      this.$emit('filtered-data', {
        radio_type: this.radioType,
        app_user: this.appUser,
        start_date: this.timesheetStartDate,
        end_date: this.timesheetEndDate,
        type: this.type,
        date_type: this.dateTypeSelected,
      });
      this.showModal = false;
    },
    async fetchAcceptedAppUsers () {
      await this.$store.dispatch('appusers/fetchAcceptedAppUsersList', {
        orgExternalId: this.selectedOrganization.organization.external_id,
        params: {
          params: {
            requestStatus: ['accepted'],
          },
        },
      });
    },
    async fetchPayItems () {
      await this.$store.dispatch('timesheets/fetchPayItems', {
        orgExtId: this.selectedOrganization.organization.external_id,
      });
    },
    fillData () {
      this.radioType =
        this.filterStoredData !== null ? this.filterStoredData.radio_type : 'all-users';
      this.timesheetStartDate =
        this.filterStoredData !== null
          ? this.filterStoredData.start_date
          : null;
      this.timesheetEndDate =
        this.filterStoredData !== null ? this.filterStoredData.end_date : null;
      this.type =
        this.filterStoredData !== null ? this.filterStoredData.type : null;
      this.appUser =
        this.filterStoredData !== null ? this.filterStoredData.app_user : null;
      this.dateTypeSelected =
        this.filterStoredData !== null ? this.filterStoredData.date_type : null;
    },
    clearFormFilter () {
      this.timesheetStartDate = null;
      this.timesheetEndDate = null;
      this.type = null;
      this.appUser = null;
      this.dateTypeSelected = null;
      this.$emit('clearedFormFilters');
      if (this.filterFrom === 'pending') {
        this.$store.dispatch('timesheets/clearStoredPendingFilteredData');
        this.$emit('remove-pending-filter-property');
      } else if (this.filterFrom === 'approved') {
        this.$store.dispatch('timesheets/clearStoredApprovedFilteredData');
        this.$emit('remove-approved-filter-property');
      } else {
        this.$store.dispatch('timesheets/clearStoredAllFilteredData');
        this.$emit('remove-all-filter-property');
      }
    },
  },
};
</script>

<style scoped>
.next-style,
.cancel-style {
  height: 30px !important;
  font-size: 12px;
  width: 80px;
  font-weight: lighter !important;
  text-transform: none !important;
}

.theme--dark.v-list {
  background-color: white !important;
}

.theme--dark >>> .v-list-item {
  color: #37474f !important;
}

.radio-group {
  margin-top: -10px !important;
}

.type-bottom {
  padding: 0px !important;
  margin: 0px !important;
}
</style>
